/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  getExamList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/class_exam/content")
        .then((response) => {
          // console.log(response)
          if (response.data.result == 'success') {
            // commit("SET_EXAM_LIST", response.data.data_list)
            resolve(response.data.data)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getContentList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/class_exam/content/list?textbook_exam_id=" + payload.textbook_exam_id)
        .then((response) => {
          // console.log(response)
          if (response.data.result == 'success') {
            commit("SET_CONTENT_LIST", response.data.data_list)
            resolve(response.data.data)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getContentMainList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("api/v2/exam/class_exam/content_main/list?content_id=" + payload.content_id)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            resolve(response.data.data_list)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getContentSubList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("api/v2/exam/class_exam/content_sub/list?content_main_id=" + payload.content_main_id)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            resolve(response.data.data_list)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  saveChapter({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.put("api/v2/exam/question_class/content", payload)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  doneExam({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.put("api/v2/exam/class_exam/content/done", payload)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
}
